import * as React from "react";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { QuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { AdditionalQuestionsSectionId, CustomQuestionConfig, FurtherQuestionsSectionTitle,
    renderAdditionalQuestions } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

interface Props {
    questionConfigs: QuestionConfig[];
    readonly: boolean;
}

export const FurtherQuestionsSection: React.FunctionComponent<Props> = (
    {
        questionConfigs,
        readonly
    }) => {

    return (
        <ContextAwareProgressBarQuestionnaireSection id={AdditionalQuestionsSectionId} title={FurtherQuestionsSectionTitle}>
            {renderAdditionalQuestions(questionConfigs as CustomQuestionConfig[], readonly, true)}
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
